import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-hourglass-spinner',
  templateUrl: './hourglass-spinner.component.html',
  styleUrls: ['./hourglass-spinner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
})
export class HourglassSpinnerComponent {}
